export const ACCOUNT_SELECT_TYPES = {
  IS_VENDOR: 'is_vendor',
  IS_CUSTOMER: 'is_customer'
}
